import { render } from "./ButtonSpinner.vue?vue&type=template&id=2178dbf7"
import script from "./ButtonSpinner.vue?vue&type=script&lang=js"
export * from "./ButtonSpinner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__